<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
//重新设置页面字体（安卓）
(function () {
  if (
    typeof WeixinJSBridge == "object" &&
    typeof WeixinJSBridge.invoke == "function"
  ) {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on("menu:setfont", function () {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    });
  }
})();
export default {
  data() {
    return {
      cid: "",
      mobile: "",
      info: {},
    };
  },
  created() {
    // console.log(window.location.href);
  },
  methods: {
    getQueryVariable(variable) {
      // 从?开始获取后面的所有数据
      var query = window.location.href.substring(1);
      // console.log(query);
      // 从字符串&开始分隔成数组split
      var vars = query.split("&");
      // 遍历该数组
      for (var i = 0; i < vars.length; i++) {
        // 从等号部分分割成字符
        var pair = vars[i].split("=");
        // 如果第一个元素等于 传进来的参的话 就输出第二个元素
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>


<style lang="less">
body {
  -webkit-text-size-adjust: 100% !important;  //解决更改手机字体后页面字体发生变化（苹果）
}
</style>
